// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import {session} from 'wix-storage';
import wixLocation from 'wix-location';
$w.onReady(function () {
	var Username = "";
	var Group = "";
	// Write your JavaScript here

	$w('#button15').onClick( () => {
		if(Username != "") Username = Username + "::"+ (1 +Math.random() * (100 - 1)).toFixed(4)
		session.setItem( "Username", Username  )
		console.log(session.getItem("Username"))
		session.setItem( "Group", Group  )
		console.log(session.getItem("Group"))
		wixLocation.to("/upbeatfestival");
	} )

	$w('#input1').onInput( (event) => {
		console.log(event.target.value)
		Username = event.target.value
	} )

	$w('#input2').onInput( (event) => {
		console.log(event.target.value)
		Group = event.target.value
	} )

});